"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subtractSet = exports.unionWith = exports.intersectWith = void 0;

function intersectWith(set2) {
  var e_1, _a;

  try {
    for (var _b = __values(this), _c = _b.next(); !_c.done; _c = _b.next()) {
      var x = _c.value;
      if (!set2.has(x)) this.delete(x);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return this;
}

exports.intersectWith = intersectWith;

function unionWith(set2) {
  var e_2, _a;

  try {
    for (var set2_1 = __values(set2), set2_1_1 = set2_1.next(); !set2_1_1.done; set2_1_1 = set2_1.next()) {
      var x = set2_1_1.value;
      this.add(x);
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (set2_1_1 && !set2_1_1.done && (_a = set2_1.return)) _a.call(set2_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  return this;
}

exports.unionWith = unionWith;

function subtractSet(set2) {
  var e_3, _a;

  try {
    for (var set2_2 = __values(set2), set2_2_1 = set2_2.next(); !set2_2_1.done; set2_2_1 = set2_2.next()) {
      var x = set2_2_1.value;
      this.delete(x);
    }
  } catch (e_3_1) {
    e_3 = {
      error: e_3_1
    };
  } finally {
    try {
      if (set2_2_1 && !set2_2_1.done && (_a = set2_2.return)) _a.call(set2_2);
    } finally {
      if (e_3) throw e_3.error;
    }
  }

  return this;
}

exports.subtractSet = subtractSet;